import {
  PAYROLL_ROSTER_FIELD_TYPE,
  type PayrollRosterField,
  type PayrollRosterValue,
} from "@/payroll/roster/types";
import { isBlankRosterValue } from "@/payroll/roster/utils/members";

export const comparePayrollRosterValues = (
  left: PayrollRosterValue | undefined,
  right: PayrollRosterValue | undefined,
  fieldType: PayrollRosterField["field_type"] | "intrinsic_text",
): number => {
  const leftBlank = isBlankRosterValue(left);
  const rightBlank = isBlankRosterValue(right);

  if (leftBlank || rightBlank) {
    if (leftBlank && rightBlank) return 0;
    return leftBlank ? 1 : -1;
  }

  if (fieldType === PAYROLL_ROSTER_FIELD_TYPE.number) {
    const leftNumber = Number(left);
    const rightNumber = Number(right);
    if (Number.isFinite(leftNumber) && Number.isFinite(rightNumber)) {
      return leftNumber - rightNumber;
    }
  }

  if (fieldType === PAYROLL_ROSTER_FIELD_TYPE.boolean) {
    return (
      Number(left === true || left === "true") -
      Number(right === true || right === "true")
    );
  }

  return String(left).localeCompare(String(right), undefined, {
    numeric: true,
    sensitivity: "base",
  });
};

export const normalizePayrollRosterSortValue = (
  value: PayrollRosterValue | undefined,
): PayrollRosterValue | undefined =>
  isBlankRosterValue(value) ? undefined : value;
